/*
* Reserve study chart - report common functions
*/

import _ from 'lodash';
import moment from 'moment';

import { Formatters } from '../common/formatters';

export const GetOrderDashLetter = (currentOrder: any): string => {
    return String.fromCharCode(65 + Formatters.getInt(currentOrder, 'dash'));
};

export const CalculateYears = 30;

export const DefaultFormValues = {
    annualIncrease: 0.03,
    perFirstYear: 12,
    percentDecimals: 7,
};

/* formdata */
export const GetFormData = (assoc: any, currentOrder: any, currentOrderChart: any): any => {
    let result = {
        scenarioObjId: '',
        scenarioName: '',
        scenarioDescription: '',
        scenarioShared: false,
        scenarioCanUpdate: false,
        myScenarios: [],
        sharedScenarios: [],

        begBalance: Formatters.getFloat(currentOrderChart, 'begBalance', 2),
        beginYear: Formatters.getInt(currentOrderChart, 'beginYear'),
        calculateYears: parseInt(_.get(currentOrderChart, 'years', CalculateYears), 10),

        currentAnnualIncrease: Formatters.getFloat(currentOrderChart, 'currentAnnualIncrease', DefaultFormValues.percentDecimals, 1, DefaultFormValues.annualIncrease),
        currentMRCVal: Formatters.getFloat(currentOrderChart, 'currentMRCVal', 2),
        currentSecondaryAnnualIncrease: Formatters.getFloat(currentOrderChart, 'currentSecondaryAnnualIncrease', DefaultFormValues.percentDecimals, 1, DefaultFormValues.annualIncrease),
        currentYears: Formatters.getInt(currentOrderChart, 'currentYears', CalculateYears),

        minimumAnnualIncrease: Formatters.getFloat(currentOrderChart, 'minimumAnnualIncrease', DefaultFormValues.percentDecimals, 1, DefaultFormValues.annualIncrease),
        minimumMRCVal: Formatters.getFloat(currentOrderChart, 'minimumMRCVal', 2),
        minimumSecondaryAnnualIncrease: Formatters.getFloat(currentOrderChart, 'minimumSecondaryAnnualIncrease', DefaultFormValues.percentDecimals, 1, DefaultFormValues.annualIncrease),
        minimumYears: Formatters.getInt(currentOrderChart, 'minimumYears', CalculateYears),

        recommendedAnnualIncrease: Formatters.getFloat(currentOrderChart, 'recommendedAnnualIncrease', DefaultFormValues.percentDecimals, 1, DefaultFormValues.annualIncrease),
        recommendedMRCVal: Formatters.getFloat(currentOrderChart, 'recommendedMRCVal', 2),
        recommendedSecondaryAnnualIncrease: Formatters.getFloat(currentOrderChart, 'recommendedSecondaryAnnualIncrease', DefaultFormValues.percentDecimals, 1, DefaultFormValues.annualIncrease),
        recommendedYears: Formatters.getInt(currentOrderChart, 'recommendedYears', CalculateYears),

        // aka idealBalance
        currentFFB: Formatters.getFloat(currentOrderChart, 'ffb', 2) ? Formatters.getFloat(currentOrderChart, 'ffb', 2) : Formatters.getFloat(currentOrderChart, 'begBalance', 2),

        draft: _.get(currentOrderChart, 'draft', true) ? true : false,
        fiscalYearEnd: Formatters.getStr(assoc, 'details.fiscalYearEnd'),
        inflation: Formatters.getFloat(currentOrderChart, 'inflation', DefaultFormValues.percentDecimals, 1), // 100),
        interest: Formatters.getFloat(currentOrderChart, 'interest', DefaultFormValues.percentDecimals, 1), // 100),
        numberUnits: Formatters.getInt(assoc, 'details.numberUnits'),
        perFirstYear: Formatters.getInt(currentOrderChart, 'perFirstYear', DefaultFormValues.perFirstYear),

        perUnitLiability: Formatters.float('0', 2, 1),
        percentFunded: Formatters.float('0', 2, 1),
        percentageFunded: Formatters.float('0', 2, 1),
        currentMrcPerUnit: Formatters.float('0', 2, 1),
        minimumMrcPerUnit: Formatters.float('0', 2, 1),
        recommendedMrcPerUnit: Formatters.float('0', 2, 1),
        minimumMrcPerUnitIncrease: Formatters.float('0', 2, 1),
        recommendedMrcPerUnitIncrease: Formatters.float('0', 2, 1),
        minimumMrcPerUnitIncreasePercent: Formatters.float('0', 2, 1),
        recommendedMrcPerUnitIncreasePercent: Formatters.float('0', 2, 1),
        monthlyFeeText: '',

        versionId: Formatters.getStr(currentOrderChart, 'versionId'),
        reportDate: currentOrder.reportDate,
        sa: Formatters.getFloat(currentOrderChart, 'sa', 2),
        currentSA: Formatters.getFloat(currentOrderChart, 'currentSA', 2, 1, 0),
        specialAssessments: (_.get(currentOrderChart, 'specialAssessments')) ? _.get(currentOrderChart, 'specialAssessments[0]') : _.get(currentOrderChart, 'specialAssessments', []),
        specialAssessmentsCustomer: (_.get(currentOrderChart, 'specialAssessmentsCustomer', [])) ? _.get(currentOrderChart, 'specialAssessmentsCustomer[0]') : _.get(currentOrderChart, 'specialAssessmentsCustomer', []),

        showMinimum: _.get(currentOrderChart, 'showMinimum', false) ? true : false,
        showRecommended: _.get(currentOrderChart, 'showRecommended', false) ? true : false,
        showYearlySummaryCurrent: _.get(currentOrderChart, 'showYearlySummaryCurrent', false) ? true : false,
        showYearlySummaryMinimum: _.get(currentOrderChart, 'showYearlySummaryMinimum', false) ? true : false,
        showYearlySummaryRecommended: _.get(currentOrderChart, 'showYearlySummaryRecommended', false) ? true : false,
        showCurrent: _.get(currentOrderChart, 'showCurrent', false) ? true : false,
        showPageNumbers: _.get(currentOrderChart, 'showPageNumbers', false) ? true : false,
        groupComponents: _.get(currentOrderChart, 'groupComponents', false) ? true : false,
        groupComponentsPictureSection: _.get(currentOrderChart, 'groupComponentsPictureSection', false) ? true : false,
        hideFooter: _.get(currentOrderChart, 'hideFooter', false) ? true : false,
        hideComponentEvaluation: _.get(currentOrderChart, 'hideComponentEvaluation', false) ? true : false,
        hideNumberOfUnits: _.get(currentOrderChart, 'hideNumberOfUnits', false) ? true : false,

        // CurrentOrder fields
        customText: Formatters.getStr(currentOrder, 'customText'),
        customTitle: Formatters.getStr(currentOrder, 'customTitle'),
        orderId: Formatters.getInt(currentOrder, 'orderId'),
        startDate: Formatters.getStr(currentOrder, 'startDate'),
        coverPagePicture: Formatters.getStr(currentOrder, 'coverPagePicture'),
        customDisclosureText: Formatters.getStr(currentOrder, 'customDisclosureText'),
        customDisclosureTitle: Formatters.getStr(currentOrder, 'customDisclosureTitle'),
        cppOverride: Formatters.getStr(currentOrder, 'cppOverride'),
        rfOverride: Formatters.getStr(currentOrder, 'rfOverride'),
        srpOverride: Formatters.getStr(currentOrder, 'srpOverride'),
        orderDashLetter: GetOrderDashLetter(currentOrder),
        orderDashNumber: Formatters.getInt(currentOrder, 'dash'),

        calculateYearsShort: parseInt(_.get(currentOrderChart, 'years', CalculateYears), 10) - 1,
        mrcValue: Formatters.getFloat(currentOrderChart, 'recommendedMRCVal').toFixed(2),
        specialAssessment: Formatters.getFloat(currentOrderChart, 'sa').toFixed(2),
        // years: Formatters.getFloat(currentOrderChart, 'recommendedYears').toFixed(0),
        years: Formatters.getFloat(currentOrderChart, 'currentYears').toFixed(0),
        orderPreparedForFYEDateFormatted: '',

        isPreliminaryStudy: _.get(currentOrder, 'isPreliminaryStudy', false) ? true : false,
    };

    // populate special assessment worksheets
    if (result.sa) {
        if (_.size(result.specialAssessments) > 0) {
            if (_.get(result.specialAssessments[0], 'year') > _.toString(result.beginYear)) {
                let entry = { id: '00', year: _.toString(result.beginYear), amount: _.toString(result.sa) };
                result.specialAssessments = _.concat(entry, result.specialAssessments);
            }
        } else {
            result.specialAssessments.push({ id: '00', year: _.toString(result.beginYear), amount: _.toString(result.sa) });
        }
    }

    if (result.currentSA) {
        if (_.size(result.specialAssessmentsCustomer) > 0) {
            if (_.get(result.specialAssessmentsCustomer[0], 'year') > _.toString(result.beginYear)) {
                let entry = { id: '00', year: _.toString(result.beginYear), amount: _.toString(result.currentSA) };
                result.specialAssessmentsCustomer = _.concat(entry, result.specialAssessmentsCustomer);
            }
        } else {
            result.specialAssessmentsCustomer.push({ id: '00', year: _.toString(result.beginYear), amount: _.toString(result.currentSA) });
        }
    }

    // Prepared for Fiscal Year End
    const orderChartBeginYear = _.get(currentOrderChart, 'beginYear');
    const assocFiscalYearEnd = _.get(assoc, 'details.fiscalYearEnd');

    if (orderChartBeginYear && assocFiscalYearEnd) {
        const fyeDateStr = `${orderChartBeginYear}/${assocFiscalYearEnd}`;
        const dateEndAssocFYE = new Date(fyeDateStr);
        const reportPeriodEndDateMoment = moment(dateEndAssocFYE);

        const preparedForFYE = moment(reportPeriodEndDateMoment).toDate();
        result.orderPreparedForFYEDateFormatted = Formatters.formatDateShortDate(preparedForFYE);
    } else {
        if (assocFiscalYearEnd) {
            result.orderPreparedForFYEDateFormatted = assocFiscalYearEnd;
        }
    }

    return result;
};



// WEBPACK FOOTER //
// ./src/report/report-common.tsx